module.exports = __webpack_public_path__ + "img/money-simple-from-bracket.d14c3df8.svg";